import * as yup from "yup";

export const createTicketValidation = yup.object({
  title: yup
    .string("Ticket title is required")
    .required("Ticket title is required"),
  details: yup
    .string("Ticket details is required")
    .required("Please fill ticket details"),
  assignee: yup
    .string("Ticket should be assigned")
    .required("Please assign ticket to someone"),
});

export const createTicketAuditorValidation = yup.object({
  title: yup
    .string("Ticket title is required")
    .required("Ticket title is required"),
  details: yup
    .string("Ticket details is required")
    .required("Please fill ticket details"),
});

export const supportTicketValidation = yup.object({
  ticketType: yup
    .string("Ticket Type is required")
    .required("Ticket Type is required"),
  title: yup
    .string("Ticket title is required")
    .required("Ticket title is required"),
  details: yup
    .string("Ticket details is required")
    .required("Please fill ticket details"),
  severity: yup
    .string("Severity is required")
    .required("Please Choose a severity"),
});
